import React from "react";
import BlockButton from "../components/block-button";
import {useTranslation} from "react-i18next";
declare var DataActivationController: any;
const Confirmation = () => {
  const { t } = useTranslation();
  const registrationCompleted = () => {
      const dataActivationController = DataActivationController;
      // @ts-ignore
      if (DataActivationController) {
          // @ts-ignore
          dataActivationController.doneSelected();
      } else {
          console.error("DataActivationController not found");
      }
  };

  return (
    <div className="layout-default">
      <h2 className="layout-default-left watch-title">
        {t("confirmationTitle")}
      </h2>
        <p>{t("emailInfo", { email: localStorage.getItem("email") ||'' })}</p>
      <p className="layout-default-left">{t("minInfo")}</p>
      <BlockButton
        onClick={registrationCompleted}
        dataTestId="done-button"
        text={t("doneButton")}
      />
      <p>{t("confirmationSubInfo")}</p>
    </div>
  );
};

export default Confirmation;
